import { render } from "./AddPerson.vue?vue&type=template&id=02ee0a66&scoped=true"
import script from "./AddPerson.vue?vue&type=script&lang=js"
export * from "./AddPerson.vue?vue&type=script&lang=js"

import "./AddPerson.vue?vue&type=style&index=0&id=02ee0a66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ee0a66"]])

export default __exports__